module.exports = __webpack_public_path__ + "img/logo_color.da9c924f.svg";